module.exports = __webpack_public_path__ + "img/icon57.dff89b1b.png";